import React from 'react';

import styles from './coachInfo.scss';

const CoachInfo = (props) => {
    const { coach } = props;

    return (
        <div className={styles.coachInfo}>
            <div className={styles.nameWrapper}>
                <div className={styles.name}>{coach.firstName} {coach.lastName}</div>
                <div className={styles.title}>{coach.relationship}</div>
            </div>
            <div className={styles.infoWrapper}>
                {(!!coach.email) && (
                    <div className={styles.email}>{coach.email}</div>
                )}
                {(!!coach.phone) && (
                    <div className={styles.phone}>{coach.phone}</div>
                )}
            </div>
        </div>
    );
};

export default CoachInfo;
